import { useDispatch } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';

import AdvancedHotkey from './component';
import { orderGridGetRates } from '../../../store/orders/grid/orders.grid.header.actions';
import { AWAITING_PAYMENT_ID, AWAITING_SHIPMENT_ID, ON_HOLD_ID } from '../../../pages/orders-page/orders-page-view-constants';
import { useTopLevelOrdersViewId } from '../../../pages/orders-page/orders-left-nav/orders-left-nav-context';

const viewsThatGetRate = [AWAITING_PAYMENT_ID, AWAITING_SHIPMENT_ID, ON_HOLD_ID];

export const messages = defineMessages({
  name: {
    description: 'get rate hotkey',
    defaultMessage: 'Get rate',
    id: 'n1eSDh',
  },
});

export const hotkey = ['r'];
export const barcodeContent = '+DF8955F67BBB=';

const GetRateHotkey = ({ children, shouldOverrideInternalDisabledLogic = false }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const viewId = useTopLevelOrdersViewId();
  const shouldGetRate = shouldOverrideInternalDisabledLogic || viewsThatGetRate.includes(viewId);
  const onUpdate = useCallback(() => {
    dispatch(orderGridGetRates());
  }, [dispatch]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onUpdate],
  );

  return (
    <>
      {shouldGetRate && <AdvancedHotkey hotkey={hotkeyMetadata} />}
      {children}
    </>
  );
};

GetRateHotkey.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  shouldOverrideInternalDisabledLogic: PropTypes.bool,
};

export default GetRateHotkey;
